<template>
    <div v-if="comStore.Races?.value.length === 0">
        <AlertMessage
            type="info"
            :show-icon="false"
        >
            <div class="d-flex gap-5">
                <IconComp
                    :icon="featureIcons.INFO"
                    class="align-self-center"
                />
                <span class="flex-fill align-self-center">{{ $t('race.missingraces') }}</span>
                <ButtonComp
                    button-type="Info"
                    icon="fa-plus"
                    class="btn-sm"
                    @click="handleClick"
                    >{{ $tm('race.newrace') }}</ButtonComp
                >
            </div>
        </AlertMessage>
    </div>
</template>

<script lang="ts" setup>
import { useEventCommonStoreRef } from '@/stores';
import AlertMessage from './AlertMessage.vue';
import { ButtonComp, IconComp } from '@/components';
import { featureIcons } from '../Menu/featureicons';
import { Router } from '@/objects/Router';

const comStore = useEventCommonStoreRef();

const props = defineProps<{
    gotoracepage?: boolean;
}>();

const handleClick = async () => {
    await Router.NavigateTo({ id: undefined, tab: 'general' }, 'races');
    await Router.NavigateTo({ id: 'new', tab: 'general' }, 'races');
    emits('createClicked');
};

const emits = defineEmits<{
    (e: 'createClicked'): void;
}>();
</script>
